const IndicatorApi_Reducer = (state =[{isLoading: true}], {type, load}) => {
    switch (type) {
             
            case 'INFORM_UI': return state.map(ob => ({...ob, ...load}))

            case 'DATA_SUCCESS': return state.map(ob => ({...ob, ...load}))

            case "DAILY_PROGRESS": return state.map(ob => ({...ob, ...load})) 

            case "DAILY_INFO": return state.map(ob => ({...ob, ...load})) 
     
        default: return state
    }
}

export default IndicatorApi_Reducer